export default __webpack_public_path__ + "static/media/claudia-christian-headshot-black-side.f229f64a.png";